import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { IWorkStreamCategory } from "./WorkStreamCategories";
import { Fetch } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";

interface IProps {
  singleData: IWorkStreamCategory;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (reload: boolean) => void;
}

const schema = yup.object({
  category_Name: yup.string().trim().required("Work Stream Category Name is required"),
});

const Form = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm<IWorkStreamCategory>({
    resolver: yupResolver(schema),
    defaultValues: { id: 0, category_Name: "" },
  });

  useEffect(() => {
    if (props.open) {
      reset({ id: props.singleData?.id ?? 0, category_Name: props.singleData?.category_Name ?? "" });
    }
  }, [props.open, props.singleData, reset]);

  const onSubmit = async (data: IWorkStreamCategory) => {
    if (props.singleData?.id && !isDirty) {
      props.toast.current.show({ severity: "info", summary: "Info", detail: "No changes found." });
      return;
    }

    try {
      setLoading(true);
      const endpoint = data.id ? `Tender_Mast/UpdateWorkStreamCategory/${data.id}` : "Tender_Mast/AddWorkStreamCategory";
      const response = await Fetch(endpoint, data.id ? "PUT" : "POST", data, null, props.toast);

      if (response?.ok) {
        props.toast.current.show({
          severity: "success",
          summary: "Success",
          detail: data.id ? "Category Updated Successfully" : "Category Added Successfully",
          life: 3000,
        });

        props.setReload(!props.reload);
        onHide();
      }
    } finally {
      setLoading(false);
    }
  };

  const onHide = () => {
    reset({ id: 0, category_Name: "" });
    props.hideDialog();
  };

  return (
    <Dialog visible={props.open} header={"Add/Edit Work Stream Category"} style={{ width: "50rem" }} modal onHide={onHide}>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
        <JVInput required label="Work Stream Category Name" control={control} name="category_Name" error={errors.category_Name?.message} />
        <div className="col-12 flex justify-content-end gap-3">
          <Button label={props.singleData?.id ? "UPDATE" : "SAVE"} type="submit" loading={loading} />
          <Button label="CLOSE" type="button" className="p-button-outlined" onClick={onHide} />
        </div>
      </form>
    </Dialog>
  );
};

export default Form;
